/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import styled from '@emotion/styled'
import { ExternalStyles, Theme } from 'bold-ui'
import useMeasure from 'hooks/useMeasure'
import React from 'react'
import { animated, useSpring } from 'react-spring'

export interface AccordionAnimation {
  children?: React.ReactNode
  style?: ExternalStyles
}

export function AccordionAnimation(props: AccordionAnimation) {
  const { children, style } = props
  const [ref, { height }] = useMeasure()
  const springProps = useSpring({ height })

  return (
    <Animation style={springProps}>
      <div ref={ref} css={css(style)}>
        {children}
      </div>
    </Animation>
  )
}

const Animation = animated(styled.div<{}, Theme>`
  overflow: hidden;
`)
